// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chip-search-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  width: 100%;
  z-index: 50;
}
.chip-search-container.focused {
  z-index: 9999;
}

.chip-search-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding-left: 4px;
}
:host-context(body.dark) .chip-search-label {
  color: #f1f5f9;
}
.chip-search-label .label-icon {
  font-size: 16px;
  color: #64748b;
}
:host-context(body.dark) .chip-search-label .label-icon {
  color: #94a3b8;
}

.chip-search-field {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 52px;
  padding: 8px 16px 8px 48px;
  background: rgba(255, 255, 255, 0.8);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 16px;
  border: 2px solid rgba(226, 232, 240, 0.8);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}
:host-context(body.dark) .chip-search-field {
  background: rgba(22, 22, 22, 0.9);
  border-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
.chip-search-container.focused .chip-search-field {
  border-color: rgba(34, 197, 94, 0.5);
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
}
:host-context(body.dark) .chip-search-container.focused .chip-search-field {
  border-color: rgba(34, 197, 94, 0.4);
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.08), 0 2px 8px rgba(0, 0, 0, 0.3);
}
.chip-search-container.has-chips .chip-search-field {
  padding-right: 72px;
}
.chip-search-container.disabled .chip-search-field {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.field-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  color: #64748b;
  z-index: 1;
  pointer-events: none;
  transition: color 0.3s ease;
}
.chip-search-container.focused .field-icon {
  color: #22c55e;
}
:host-context(body.dark) .field-icon {
  color: #94a3b8;
}

.chips-input-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.chip-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px 4px 12px;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(34, 197, 94, 0.25);
  animation: chipEnter 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  transition: all 0.2s ease;
  max-width: 180px;
}
.chip-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.35);
}
.chip-item .chip-text {
  font-size: 12px;
  font-weight: 600;
  color: white;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}
.chip-item .chip-remove {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  margin: 0;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
.chip-item .chip-remove ion-icon {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.2s ease;
}
.chip-item .chip-remove:hover {
  background: rgba(255, 255, 255, 0.35);
  transform: scale(1.1) rotate(90deg);
}
.chip-item .chip-remove:hover ion-icon {
  color: white;
}
.chip-item .chip-remove:active {
  transform: scale(0.95);
}

@keyframes chipEnter {
  from {
    opacity: 0;
    transform: scale(0.6);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.search-input {
  flex: 1;
  min-width: 100px;
  height: 36px;
  padding: 0;
  margin: 0;
  background: transparent;
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  color: #1e293b;
}
:host-context(body.dark) .search-input {
  color: #f1f5f9;
}
.search-input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}
:host-context(body.dark) .search-input::placeholder {
  color: #64748b;
}
.search-input:disabled {
  cursor: not-allowed;
}

.clear-all-btn {
  position: absolute;
  right: 36px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 2;
  transition: all 0.3s ease;
}
.clear-all-btn ion-icon {
  font-size: 22px;
  color: #ef4444;
  transition: all 0.3s ease;
}
.clear-all-btn:hover {
  transform: translateY(-50%) scale(1.15) rotate(90deg);
}
.clear-all-btn:hover ion-icon {
  color: #dc2626;
  filter: drop-shadow(0 2px 4px rgba(239, 68, 68, 0.3));
}

.chip-count-badge {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  border-radius: 11px;
  font-size: 11px;
  font-weight: 700;
  color: white;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(34, 197, 94, 0.3);
  animation: badgePop 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes badgePop {
  from {
    transform: translateY(-50%) scale(0.5);
    opacity: 0;
  }
  to {
    transform: translateY(-50%) scale(1);
    opacity: 1;
  }
}
.suggestions-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  z-index: 9999;
  background: rgba(255, 255, 255, 0.95);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
          backdrop-filter: blur(20px) saturate(180%);
  border-radius: 16px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12), 0 4px 16px rgba(0, 0, 0, 0.06), 0 1px 0 rgba(255, 255, 255, 0.8) inset;
  overflow: hidden;
  animation: dropdownSlide 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}
:host-context(body.dark) .suggestions-dropdown {
  background: rgba(30, 30, 30, 0.95);
  border-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4), 0 4px 16px rgba(0, 0, 0, 0.2), 0 1px 0 rgba(255, 255, 255, 0.05) inset;
}

@keyframes dropdownSlide {
  from {
    opacity: 0;
    transform: translateY(-8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.suggestions-list {
  max-height: 240px;
  overflow-y: auto;
  padding: 6px;
}
.suggestions-list::-webkit-scrollbar {
  width: 6px;
}
.suggestions-list::-webkit-scrollbar-track {
  background: transparent;
}
.suggestions-list::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.3);
  border-radius: 3px;
}
.suggestions-list::-webkit-scrollbar-thumb:hover {
  background: rgba(148, 163, 184, 0.5);
}
:host-context(body.dark) .suggestions-list::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.2);
}
:host-context(body.dark) .suggestions-list::-webkit-scrollbar-thumb:hover {
  background: rgba(148, 163, 184, 0.4);
}

.suggestion-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 14px;
  background: transparent;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  text-align: left;
  font-family: inherit;
}
.suggestion-item .suggestion-icon {
  font-size: 18px;
  color: #64748b;
  flex-shrink: 0;
  transition: color 0.2s ease;
}
:host-context(body.dark) .suggestion-item .suggestion-icon {
  color: #94a3b8;
}
.suggestion-item .suggestion-text {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:host-context(body.dark) .suggestion-item .suggestion-text {
  color: #e2e8f0;
}
.suggestion-item .suggestion-add-icon {
  font-size: 18px;
  color: #22c55e;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.2s ease;
  flex-shrink: 0;
}
.suggestion-item:hover, .suggestion-item.focused {
  background: rgba(34, 197, 94, 0.08);
}
:host-context(body.dark) .suggestion-item:hover, :host-context(body.dark) .suggestion-item.focused {
  background: rgba(34, 197, 94, 0.12);
}
.suggestion-item:hover .suggestion-icon, .suggestion-item.focused .suggestion-icon {
  color: #22c55e;
}
.suggestion-item:hover .suggestion-text, .suggestion-item.focused .suggestion-text {
  color: #1e293b;
}
:host-context(body.dark) .suggestion-item:hover .suggestion-text, :host-context(body.dark) .suggestion-item.focused .suggestion-text {
  color: #f1f5f9;
}
.suggestion-item:hover .suggestion-add-icon, .suggestion-item.focused .suggestion-add-icon {
  opacity: 1;
  transform: scale(1);
}
.suggestion-item:active {
  background: rgba(34, 197, 94, 0.15);
  transform: scale(0.98);
}

.no-results-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px 16px;
  color: #94a3b8;
}
.no-results-content ion-icon {
  font-size: 20px;
}
.no-results-content span {
  font-size: 14px;
  font-weight: 500;
}
:host-context(body.dark) .no-results-content {
  color: #64748b;
}

@media (max-width: 768px) {
  .chip-search-field {
    min-height: 48px;
    padding: 6px 14px 6px 44px;
  }
  .field-icon {
    left: 14px;
    font-size: 18px;
  }
  .chip-item {
    padding: 3px 6px 3px 10px;
    max-width: 150px;
  }
  .chip-item .chip-text {
    font-size: 11px;
  }
  .chip-item .chip-remove {
    width: 18px;
    height: 18px;
  }
  .chip-item .chip-remove ion-icon {
    font-size: 12px;
  }
  .search-input {
    min-width: 80px;
    height: 32px;
    font-size: 13px;
  }
  .suggestions-dropdown {
    border-radius: 12px;
  }
  .suggestion-item {
    padding: 8px 12px;
    gap: 8px;
  }
  .suggestion-item .suggestion-text {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/chip-search-input/chip-search-input.component.scss"],"names":[],"mappings":"AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;AAHF;AAKE;EACE,aAAA;AAHJ;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;AALF;AAOE;EACE,cAAA;AALJ;AAQE;EACE,eAAA;EACA,cAAA;AANJ;AAQI;EACE,cAAA;AANN;;AAYA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,0BAAA;EACA,oCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,mBAAA;EACA,0CAAA;EACA,yCAAA;EACA,kDAAA;AATF;AAWE;EACE,iCAAA;EACA,uCAAA;EACA,wCAAA;AATJ;AAaE;EACE,oCAAA;EACA,2EACE;AAZN;AAeI;EACE,oCAAA;EACA,2EACE;AAdR;AAoBE;EACE,mBAAA;AAlBJ;AAsBE;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AApBJ;;AAyBA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,oBAAA;EACA,2BAAA;AAtBF;AAwBE;EACE,cAAA;AAtBJ;AAyBE;EACE,cAAA;AAvBJ;;AA4BA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;AAzBF;;AA6BA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,6DAAA;EACA,mBAAA;EACA,6CAAA;EACA,uDAAA;EACA,yBAAA;EACA,gBAAA;AA1BF;AA4BE;EACE,2BAAA;EACA,8CAAA;AA1BJ;AA6BE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,0CAAA;AA3BJ;AA8BE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AA5BJ;AA8BI;EACE,eAAA;EACA,+BAAA;EACA,2BAAA;AA5BN;AA+BI;EACE,qCAAA;EACA,mCAAA;AA7BN;AA+BM;EACE,YAAA;AA7BR;AAiCI;EACE,sBAAA;AA/BN;;AAoCA;EACE;IACE,UAAA;IACA,qBAAA;EAjCF;EAmCA;IACE,UAAA;IACA,mBAAA;EAjCF;AACF;AAqCA;EACE,OAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AAnCF;AAqCE;EACE,cAAA;AAnCJ;AAsCE;EACE,cAAA;EACA,gBAAA;AApCJ;AAsCI;EACE,cAAA;AApCN;AAwCE;EACE,mBAAA;AAtCJ;;AA2CA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,yBAAA;AAxCF;AA0CE;EACE,eAAA;EACA,cAAA;EACA,yBAAA;AAxCJ;AA2CE;EACE,qDAAA;AAzCJ;AA2CI;EACE,cAAA;EACA,qDAAA;AAzCN;;AA+CA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,6DAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,4CAAA;EACA,sDAAA;AA5CF;;AA+CA;EACE;IACE,sCAAA;IACA,UAAA;EA5CF;EA8CA;IACE,oCAAA;IACA,UAAA;EA5CF;AACF;AAgDA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,qCAAA;EACA,kDAAA;UAAA,0CAAA;EACA,mBAAA;EACA,0CAAA;EACA,mHACE;EAGF,gBAAA;EACA,4DAAA;AAjDF;AAmDE;EACE,kCAAA;EACA,sCAAA;EACA,kHACE;AAlDN;;AAwDA;EACE;IACE,UAAA;IACA,uCAAA;EArDF;EAuDA;IACE,UAAA;IACA,iCAAA;EArDF;AACF;AAyDA;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;AAvDF;AA0DE;EACE,UAAA;AAxDJ;AA2DE;EACE,uBAAA;AAzDJ;AA4DE;EACE,oCAAA;EACA,kBAAA;AA1DJ;AA4DI;EACE,oCAAA;AA1DN;AA+DI;EACE,oCAAA;AA7DN;AA+DM;EACE,oCAAA;AA7DR;;AAoEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,kDAAA;EACA,gBAAA;EACA,oBAAA;AAjEF;AAmEE;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,2BAAA;AAjEJ;AAmEI;EACE,cAAA;AAjEN;AAqEE;EACE,OAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAnEJ;AAqEI;EACE,cAAA;AAnEN;AAuEE;EACE,eAAA;EACA,cAAA;EACA,UAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AArEJ;AAwEE;EAEE,mCAAA;AAvEJ;AAyEI;EACE,mCAAA;AAvEN;AA0EI;EACE,cAAA;AAxEN;AA2EI;EACE,cAAA;AAzEN;AA2EM;EACE,cAAA;AAzER;AA6EI;EACE,UAAA;EACA,mBAAA;AA3EN;AA+EE;EACE,mCAAA;EACA,sBAAA;AA7EJ;;AAkFA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;AA/EF;AAiFE;EACE,eAAA;AA/EJ;AAkFE;EACE,eAAA;EACA,gBAAA;AAhFJ;AAmFE;EACE,cAAA;AAjFJ;;AAsFA;EACE;IACE,gBAAA;IACA,0BAAA;EAnFF;EAsFA;IACE,UAAA;IACA,eAAA;EApFF;EAuFA;IACE,yBAAA;IACA,gBAAA;EArFF;EAuFE;IACE,eAAA;EArFJ;EAwFE;IACE,WAAA;IACA,YAAA;EAtFJ;EAwFI;IACE,eAAA;EAtFN;EA2FA;IACE,eAAA;IACA,YAAA;IACA,eAAA;EAzFF;EA4FA;IACE,mBAAA;EA1FF;EA6FA;IACE,iBAAA;IACA,QAAA;EA3FF;EA6FE;IACE,eAAA;EA3FJ;AACF","sourcesContent":["// ===== ULTRA-PREMIUM CHIP SEARCH INPUT =====\n// Glassmorphism, animazioni cinematiche, supporto dark/light theme\n\n// === CONTAINER ===\n.chip-search-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  position: relative;\n  width: 100%;\n  z-index: 50;\n\n  &.focused {\n    z-index: 9999;\n  }\n}\n\n// === LABEL ===\n.chip-search-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #475569;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  padding-left: 4px;\n\n  :host-context(body.dark) & {\n    color: #f1f5f9;\n  }\n\n  .label-icon {\n    font-size: 16px;\n    color: #64748b;\n\n    :host-context(body.dark) & {\n      color: #94a3b8;\n    }\n  }\n}\n\n// === MAIN FIELD ===\n.chip-search-field {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 52px;\n  padding: 8px 16px 8px 48px;\n  background: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(10px);\n  border-radius: 16px;\n  border: 2px solid rgba(226, 232, 240, 0.8);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n\n  :host-context(body.dark) & {\n    background: rgba(22, 22, 22, 0.9);\n    border-color: rgba(255, 255, 255, 0.15);\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n  }\n\n  // Focus state\n  .chip-search-container.focused & {\n    border-color: rgba(34, 197, 94, 0.5);\n    box-shadow:\n      0 0 0 4px rgba(34, 197, 94, 0.1),\n      0 2px 8px rgba(0, 0, 0, 0.06);\n\n    :host-context(body.dark) & {\n      border-color: rgba(34, 197, 94, 0.4);\n      box-shadow:\n        0 0 0 4px rgba(34, 197, 94, 0.08),\n        0 2px 8px rgba(0, 0, 0, 0.3);\n    }\n  }\n\n  // Has chips state\n  .chip-search-container.has-chips & {\n    padding-right: 72px; // Space for badge + clear button\n  }\n\n  // Disabled state\n  .chip-search-container.disabled & {\n    opacity: 0.5;\n    cursor: not-allowed;\n    pointer-events: none;\n  }\n}\n\n// === FIELD ICON ===\n.field-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 20px;\n  color: #64748b;\n  z-index: 1;\n  pointer-events: none;\n  transition: color 0.3s ease;\n\n  .chip-search-container.focused & {\n    color: #22c55e;\n  }\n\n  :host-context(body.dark) & {\n    color: #94a3b8;\n  }\n}\n\n// === CHIPS + INPUT WRAPPER ===\n.chips-input-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n}\n\n// === CHIP ITEM ===\n.chip-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px 4px 12px;\n  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);\n  border-radius: 20px;\n  box-shadow: 0 2px 8px rgba(34, 197, 94, 0.25);\n  animation: chipEnter 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  transition: all 0.2s ease;\n  max-width: 180px;\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(34, 197, 94, 0.35);\n  }\n\n  .chip-text {\n    font-size: 12px;\n    font-weight: 600;\n    color: white;\n    line-height: 1.2;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n  }\n\n  .chip-remove {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    padding: 0;\n    margin: 0;\n    background: rgba(255, 255, 255, 0.2);\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    flex-shrink: 0;\n\n    ion-icon {\n      font-size: 14px;\n      color: rgba(255, 255, 255, 0.8);\n      transition: color 0.2s ease;\n    }\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.35);\n      transform: scale(1.1) rotate(90deg);\n\n      ion-icon {\n        color: white;\n      }\n    }\n\n    &:active {\n      transform: scale(0.95);\n    }\n  }\n}\n\n@keyframes chipEnter {\n  from {\n    opacity: 0;\n    transform: scale(0.6);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n// === SEARCH INPUT ===\n.search-input {\n  flex: 1;\n  min-width: 100px;\n  height: 36px;\n  padding: 0;\n  margin: 0;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: inherit;\n  color: #1e293b;\n\n  :host-context(body.dark) & {\n    color: #f1f5f9;\n  }\n\n  &::placeholder {\n    color: #94a3b8;\n    font-weight: 400;\n\n    :host-context(body.dark) & {\n      color: #64748b;\n    }\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n}\n\n// === CLEAR ALL BUTTON ===\n.clear-all-btn {\n  position: absolute;\n  right: 36px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  z-index: 2;\n  transition: all 0.3s ease;\n\n  ion-icon {\n    font-size: 22px;\n    color: #ef4444;\n    transition: all 0.3s ease;\n  }\n\n  &:hover {\n    transform: translateY(-50%) scale(1.15) rotate(90deg);\n\n    ion-icon {\n      color: #dc2626;\n      filter: drop-shadow(0 2px 4px rgba(239, 68, 68, 0.3));\n    }\n  }\n}\n\n// === CHIP COUNT BADGE ===\n.chip-count-badge {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 22px;\n  height: 22px;\n  padding: 0 6px;\n  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);\n  border-radius: 11px;\n  font-size: 11px;\n  font-weight: 700;\n  color: white;\n  z-index: 2;\n  box-shadow: 0 2px 6px rgba(34, 197, 94, 0.3);\n  animation: badgePop 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes badgePop {\n  from {\n    transform: translateY(-50%) scale(0.5);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(-50%) scale(1);\n    opacity: 1;\n  }\n}\n\n// === SUGGESTIONS DROPDOWN ===\n.suggestions-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  right: 0;\n  z-index: 9999;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px) saturate(180%);\n  border-radius: 16px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  box-shadow:\n    0 12px 40px rgba(0, 0, 0, 0.12),\n    0 4px 16px rgba(0, 0, 0, 0.06),\n    0 1px 0 rgba(255, 255, 255, 0.8) inset;\n  overflow: hidden;\n  animation: dropdownSlide 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n\n  :host-context(body.dark) & {\n    background: rgba(30, 30, 30, 0.95);\n    border-color: rgba(255, 255, 255, 0.1);\n    box-shadow:\n      0 12px 40px rgba(0, 0, 0, 0.4),\n      0 4px 16px rgba(0, 0, 0, 0.2),\n      0 1px 0 rgba(255, 255, 255, 0.05) inset;\n  }\n}\n\n@keyframes dropdownSlide {\n  from {\n    opacity: 0;\n    transform: translateY(-8px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n// === SUGGESTIONS LIST ===\n.suggestions-list {\n  max-height: 240px;\n  overflow-y: auto;\n  padding: 6px;\n\n  // Custom scrollbar\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(148, 163, 184, 0.3);\n    border-radius: 3px;\n\n    &:hover {\n      background: rgba(148, 163, 184, 0.5);\n    }\n  }\n\n  :host-context(body.dark) & {\n    &::-webkit-scrollbar-thumb {\n      background: rgba(148, 163, 184, 0.2);\n\n      &:hover {\n        background: rgba(148, 163, 184, 0.4);\n      }\n    }\n  }\n}\n\n// === SUGGESTION ITEM ===\n.suggestion-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 14px;\n  background: transparent;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n  text-align: left;\n  font-family: inherit;\n\n  .suggestion-icon {\n    font-size: 18px;\n    color: #64748b;\n    flex-shrink: 0;\n    transition: color 0.2s ease;\n\n    :host-context(body.dark) & {\n      color: #94a3b8;\n    }\n  }\n\n  .suggestion-text {\n    flex: 1;\n    font-size: 14px;\n    font-weight: 500;\n    color: #334155;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    :host-context(body.dark) & {\n      color: #e2e8f0;\n    }\n  }\n\n  .suggestion-add-icon {\n    font-size: 18px;\n    color: #22c55e;\n    opacity: 0;\n    transform: scale(0.8);\n    transition: all 0.2s ease;\n    flex-shrink: 0;\n  }\n\n  &:hover,\n  &.focused {\n    background: rgba(34, 197, 94, 0.08);\n\n    :host-context(body.dark) & {\n      background: rgba(34, 197, 94, 0.12);\n    }\n\n    .suggestion-icon {\n      color: #22c55e;\n    }\n\n    .suggestion-text {\n      color: #1e293b;\n\n      :host-context(body.dark) & {\n        color: #f1f5f9;\n      }\n    }\n\n    .suggestion-add-icon {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n\n  &:active {\n    background: rgba(34, 197, 94, 0.15);\n    transform: scale(0.98);\n  }\n}\n\n// === NO RESULTS ===\n.no-results-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 20px 16px;\n  color: #94a3b8;\n\n  ion-icon {\n    font-size: 20px;\n  }\n\n  span {\n    font-size: 14px;\n    font-weight: 500;\n  }\n\n  :host-context(body.dark) & {\n    color: #64748b;\n  }\n}\n\n// === RESPONSIVE ===\n@media (max-width: 768px) {\n  .chip-search-field {\n    min-height: 48px;\n    padding: 6px 14px 6px 44px;\n  }\n\n  .field-icon {\n    left: 14px;\n    font-size: 18px;\n  }\n\n  .chip-item {\n    padding: 3px 6px 3px 10px;\n    max-width: 150px;\n\n    .chip-text {\n      font-size: 11px;\n    }\n\n    .chip-remove {\n      width: 18px;\n      height: 18px;\n\n      ion-icon {\n        font-size: 12px;\n      }\n    }\n  }\n\n  .search-input {\n    min-width: 80px;\n    height: 32px;\n    font-size: 13px;\n  }\n\n  .suggestions-dropdown {\n    border-radius: 12px;\n  }\n\n  .suggestion-item {\n    padding: 8px 12px;\n    gap: 8px;\n\n    .suggestion-text {\n      font-size: 13px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
